import { ApiError, apiFetch, clearToken, getToken, setToken } from './client';
export function mapApiRole(role) {
    if (role === 'admin')
        return 'admin';
    if (role === 'reader')
        return 'reader';
    return 'editor';
}
export function roleCanEdit(role) {
    return role === 'admin' || role === 'editor';
}
export function roleBadgeLabel(role) {
    if (role === 'admin')
        return 'Админ';
    if (role === 'editor')
        return 'Редактор';
    return 'Просмотр';
}
export function toAuthUser(u) {
    return {
        email: u.email,
        name: u.fullName,
        fullName: u.fullName,
        firstName: u.firstName,
        lastName: u.lastName,
        jobTitle: u.jobTitle,
        role: u.role,
        passwordUnset: u.passwordUnset,
    };
}
export function userInitials(firstName, lastName) {
    const f = firstName.trim()[0]?.toUpperCase() ?? '';
    const l = lastName.trim()[0]?.toUpperCase() ?? '';
    return f + l || '?';
}
function authErrorMessage(err, fallback) {
    if (err instanceof ApiError) {
        switch (err.code) {
            case 'invalid_payload':
                return 'Проверьте введённые данные';
            case 'wrong_current_password':
                return 'Неверный текущий пароль';
            default:
                return fallback;
        }
    }
    return fallback;
}
export async function patchProfile(fields) {
    try {
        const data = await apiFetch('/auth/profile', {
            method: 'PATCH',
            body: JSON.stringify(fields),
        });
        return toAuthUser(data.user);
    }
    catch (err) {
        throw new Error(authErrorMessage(err, 'Не удалось сохранить профиль'));
    }
}
export async function changePassword(currentPassword, newPassword) {
    try {
        await apiFetch('/auth/change-password', {
            method: 'POST',
            body: JSON.stringify({ currentPassword, newPassword }),
        });
    }
    catch (err) {
        throw new Error(authErrorMessage(err, 'Не удалось изменить пароль'));
    }
}
export async function loginRequest(email, password) {
    const data = await apiFetch('/auth/login', {
        method: 'POST',
        body: JSON.stringify({ email, password }),
    });
    setToken(data.token);
    return { ...toAuthUser(data.user), token: data.token };
}
export async function login(email, password) {
    const result = await loginRequest(email, password);
    return result;
}
export async function getMe() {
    const data = await apiFetch('/auth/me');
    return toAuthUser(data.user);
}
export async function logoutRequest() {
    try {
        if (getToken()) {
            await apiFetch('/auth/logout', { method: 'POST' });
        }
    }
    finally {
        clearToken();
    }
}
export { clearToken, getToken, setToken };
